/**
 * /onboarding/consensi-rifiutati — esito dopo un rifiuto di un consenso
 * bloccante. Il token NON e' stato consumato: il link resta valido.
 */

import { OnboardingShell } from '../components/OnboardingShell';
import {
  STUDIO_EMAIL,
  STUDIO_TELEFONO,
  STUDIO_TELEFONO_E164,
} from '../lib/studio-contatti';

export function OnboardingConsensiRifiutatiPage() {
  return (
    <OnboardingShell>
      <div className="text-center py-8 md:py-16">
        <div
          className="w-16 h-16 mx-auto mb-6 rounded-full bg-error-container flex items-center justify-center"
          aria-hidden="true"
        >
          <span className="material-symbols-outlined text-on-error-container text-3xl">
            info
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-text-main mb-3">
          Non possiamo procedere senza il tuo consenso
        </h1>
        <p className="text-text-secondary text-base md:text-lg mb-3">
          Hai scelto di non accettare un consenso necessario per le
          prestazioni dello Studio. Senza quel consenso non possiamo
          prenderti in carico.
        </p>
        <p className="text-text-secondary text-sm md:text-base mb-3">
          Il tuo link resta valido: se cambi idea puoi tornare indietro e
          completare la compilazione.
        </p>
        <p className="text-text-secondary text-sm md:text-base">
          Per qualsiasi domanda, contatta lo Studio.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 items-center justify-center">
          <a
            href={`tel:${STUDIO_TELEFONO_E164}`}
            className="inline-block px-6 py-3 rounded-lg bg-primary text-on-primary text-base font-semibold min-h-[44px]"
          >
            Chiama {STUDIO_TELEFONO}
          </a>
          <a
            href={`mailto:${STUDIO_EMAIL}`}
            className="inline-block px-6 py-3 rounded-lg border border-outline text-text-main bg-surface-container-lowest text-base font-semibold min-h-[44px]"
          >
            Scrivi una email
          </a>
        </div>
      </div>
    </OnboardingShell>
  );
}
